import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtNumber, fmtDate } from "@/lib/api";
import { ALERT_STYLES } from "@/components/AlertChip";
import { Bell, Warning, CircleNotch, CheckCircle } from "@phosphor-icons/react";

const GROUPS = [
  { key: "vencido", title: "Vencidos", desc: "Ya superaron su fecha de vencimiento" },
  { key: "red", title: "Críticos · menos de 7 días", desc: "Requieren acción inmediata" },
  { key: "yellow", title: "Advertencia · menos de 15 días", desc: "Planifica su salida pronto" },
  { key: "orange", title: "Próximos · menos de 30 días", desc: "Monitorea su rotación" },
];

function LoteRow({ lote, level }) {
  const s = ALERT_STYLES[level];
  return (
    <Link
      to={`/lotes/${lote.id}`}
      data-testid={`alerta-lote-${lote.id}`}
      className="flex items-center justify-between px-5 py-3 border-t border-[#E2E8F0] hover:bg-[#F8F9FA] transition-colors"
    >
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-2 h-8 rounded-full shrink-0" style={{ backgroundColor: s.text }} />
        <div className="min-w-0">
          <div className="font-semibold text-[#0F172A] truncate">{lote.nombre}</div>
          <div className="text-xs text-[#64748B]">{lote.numero_lote} · stock {fmtNumber(lote.stock_actual)}</div>
        </div>
      </div>
      <div className="text-right shrink-0 ml-3">
        <div className="text-sm font-bold" style={{ color: s.text }}>
          {level === "vencido" ? `Vencido hace ${Math.abs(lote.dias_hasta_vencimiento)}d` : `${lote.dias_hasta_vencimiento} días`}
        </div>
        <div className="text-xs text-[#64748B]">{fmtDate(lote.fecha_vencimiento)}</div>
      </div>
    </Link>
  );
}

export default function Alertas() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/alertas").then((r) => setData(r.data));
  }, []);

  if (!data) {
    return (
      <div className="flex items-center justify-center py-32">
        <CircleNotch size={32} className="animate-spin text-[#0F172A]" />
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-up" data-testid="alertas-page">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-md bg-[#FFF7ED] flex items-center justify-center">
          <Bell size={22} weight="bold" className="text-[#9A3412]" />
        </span>
        <div>
          <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-[#0F172A]">Alertas de vencimiento</h1>
          <p className="text-[#475569] mt-1">{data.total} lotes requieren tu atención.</p>
        </div>
      </div>

      {data.total === 0 ? (
        <div className="bg-white border border-[#E2E8F0] rounded-md p-12 text-center">
          <CheckCircle size={48} weight="duotone" className="mx-auto text-[#10B981] mb-4" />
          <h2 className="font-heading text-xl font-bold text-[#0F172A]">Todo en orden</h2>
          <p className="text-[#64748B] mt-1">Ningún lote vence en los próximos 30 días.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {GROUPS.map((g) => {
            const items = data[g.key] || [];
            if (items.length === 0) return null;
            const s = ALERT_STYLES[g.key];
            return (
              <div key={g.key} className="bg-white border border-[#E2E8F0] rounded-md overflow-hidden" data-testid={`alerta-group-${g.key}`}>
                <div className="px-5 py-4 flex items-center gap-3" style={{ backgroundColor: s.bg, borderBottom: `1px solid ${s.border}` }}>
                  <Warning size={20} weight="bold" style={{ color: s.text }} />
                  <div>
                    <h2 className="font-heading font-bold" style={{ color: s.text }}>{g.title}</h2>
                    <p className="text-xs" style={{ color: s.text, opacity: 0.8 }}>{g.desc} · {items.length} lote(s)</p>
                  </div>
                </div>
                <div>
                  {items.map((l) => (
                    <LoteRow key={l.id} lote={l} level={g.key} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
